import Vue from 'vue/dist/vue.esm'
import {TheMask, mask} from 'vue-the-mask'
import TableRow from '../../javascripts/mixins/tableRow'
import 'bootstrap/dist/js/bootstrap';
import CPF from 'cpf-check'
import Utils from '../../javascripts/utils'


document.addEventListener('DOMContentLoaded', () => {
    const form_app = new Vue({
      el: '#signup_form',
      mixins: [TableRow],
      components: {
        TheMask
      },
      directives: {mask},
      data: {
        name: '',
        name_error: '',
        email: '',
        email_error: '',
        password: '',
        password_error: '',
        password_confirmation: '',
        password_confirmation_error: '',
        cpf: '',
        cpf_error: '',
        job_title: '',
        job_title_error: '',
        id_number: '',
        id_number_error: '',
        birthdate: '',
        birthdate_error: '',
        dispatcher: '',
        dispatcher_error: '',
        to_proposal: '',
      },
      computed: {
        base_input_name: function () {
            return 'user'
        },
        base_input_id: function () {
            return 'user'
        },
        mandatory_message: function () {
            return "Este campo é obrigatório"
        },
        incorrect_format_message: function () {
            return "Valor inválido"
        },
        user_name_is_valid: function () {
            let name_splits_length
            if (this.name == ''){
                this.name_error = this.mandatory_message
                return false
            }
            name_splits_length = this.name.replace(/[0-9]/g, '').trim().split(' ').length;
            if(name_splits_length<2){
              this.name_error = 'Informe pelo menos nome e sobrenome';
              return false;
            }
            if (/\d/.test(this.name)) {
                this.name_error = 'O nome deve conter apenas letras';
                return false;
            }
            this.name_error = ''
            return true
        },
        user_email_is_valid: function () {
            if (this.email == ''){
                this.email_error = this.mandatory_message
                return false
            }
            if(!Utils.checkEmail(this.email)){
                this.email_error = "Email inválido"
                return false
            }
            this.email_error = ''
            return true
        },
        user_password_is_valid: function () {
            if (this.password == ''){
                this.password_error = this.mandatory_message
                return false
            }
            if(this.password.length < 8){
                this.password_error = "A senha deve ter no mínimo 8 caracteres";
                return false;
            }
            this.password_error = ''
            return true
        },
        user_password_confirmation_is_valid: function () {
            if (this.password_confirmation == ''){
                this.password_confirmation_error = this.mandatory_message
                return false
            }
            if(this.password_confirmation.length < 8){
                this.password_confirmation_error = "A senha deve ter no mínimo 8 caracteres"
                return false;
            }
            this.password_confirmation_error = ''
            return true
        },
        user_dispatcher_is_valid: function () {
            if (this.dispatcher == ''){
                this.dispatcher_error = this.mandatory_message
                return false
            }
            if (/\d/.test(this.dispatcher)) {
                this.dispatcher_error = 'O orgão expedidor deve conter apenas letras';
                return false;
            }
            this.dispatcher_error = ''
            return true
        },
        user_birthdate_is_valid: function(){
            this.birthdate_error = '';
            if(this.birthdate==''){
                this.birthdate_error = this.mandatory_message;
                return false;
            }
            if(this.birthdate.length<10){
                this.birthdate_error = 'Data de nascimento inválida';
                return false;
            }
            if(!Utils.checkDate(this.birthdate)){
                this.birthdate_error = "Data de Nascimento inválida"
                return false
            }
            var currentDate = new Date();
            var selectedDate = new Date(this.birthdate);
            var age = currentDate.getFullYear() - selectedDate.getFullYear();
            var monthDiff = currentDate.getMonth() - selectedDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < selectedDate.getDate())) {
                age--;
            }
        
            if (age <= 16) {
                this.birthdate_error = 'Data de Nascimento inválida';
                return false;
            }
            if (age > 150) {
                this.birthdate_error = 'Data de Nascimento inválida';
                return false;
            }
            return true;
        },
        cpf_is_valid: function () {
            if (this.cpf == ''){
                this.cpf_error = this.mandatory_message
                return false
            }

            if (!CPF.validate(this.cpf)){
                this.cpf_error = this.incorrect_format_message
                return false
            }
            this.cpf_error = ''
            return true
        },
        id_number_is_valid: function () {
            if (this.id_number == ''){
                this.id_number_error = this.mandatory_message
                return false
            }
            if (/[a-zA-Z]/.test(this.id_number)) {
                this.id_number_error = 'O RG deve conter apenas números';
                return false;
            }

            // if (this.id_number.length < 7){
            //     this.id_number_error = 'RG deve possuir 5 números'
            //     return false
            // }
            this.id_number_error = ''
            return true
        },
        password_valid: function(){
            var error_msg = "A confirmação da senha não é igual a senha informada"
            if(!this.user_password_is_valid | !this.user_password_confirmation_is_valid){
                return false;
            }
            if(this.password!=this.password_confirmation){
                this.password_error = error_msg
                this.password_confirmation_error = error_msg
                return false;
            }
            return true;
        },
        job_title_valid: function(){
            this.job_title_error = '';
            if(this.job_title==''){
                this.job_title_error = this.mandatory_message;
                return false;
            }
            return true;
        }
      },
      methods:{
        inputId: function (attribute) {
            return `${this.base_input_id}_${attribute}`
        },
        getInitialData: function () {
            var data = this.$el.dataset;
            this.name = data['name']==null ? '' : data['name']
            this.email = data['email']==null ? '' : data['email']
            this.cpf = data['cpf']==null? '' : data['cpf']
            this.birthdate = data['birthdate']==null? '' : data['birthdate'];
            this.job_title = data['jobTitle']==null? '' : data['jobTitle']
            this.id_number = data['idNumber']==null? '' : data['idNumber'];
            this.dispatcher = data['dispatcher']==null? '' : data['dispatcher'];
            this.to_proposal = data['toProposal']=="true" ? true : false
        },
        checkFields: function(e){
            let is_valid = true

            is_valid &= this.user_name_is_valid 
                    & this.user_email_is_valid
                    & this.cpf_is_valid
                    & this.id_number_is_valid
                    & this.user_dispatcher_is_valid
                    & this.user_birthdate_is_valid
                    & this.password_valid
                    & this.job_title_valid;

            return is_valid;
        },
        checkForm: function(e){
            let is_valid = this.checkFields();

            if(!is_valid){
                e.preventDefault();
                return false;
            }
            return true;
        },
        preventModal:function(e){
            let is_valid = this.checkFields();

            if(!is_valid){
                e.stopPropagation();
                return false;
            }
            return true;
        },
        setToProposalToTrue: function(e){
            this.to_proposal = true;
        }
      },
      beforeMount() {
        this.getInitialData();
      }
    });
});